export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) { 
      $(`#${widgetName} .buttonwrap a`).addClass('button'); 
      const cardWidget = document.getElementById('cardWidget');

      // Get all card-widget-item elements within cardWidget
      const cardItems = cardWidget.querySelectorAll('.card-widget-item');

      // Loop through card-widget-item elements and wrap every two in a div
      for (let i = 0; i < cardItems.length; i += 2) {
          const wrapper = document.createElement('div');
          wrapper.className = 'pair-wrapper'; // Optional class for styling
          cardItems[i].parentNode.insertBefore(wrapper, cardItems[i]);
          wrapper.appendChild(cardItems[i]);
          if (cardItems[i + 1]) {
              wrapper.appendChild(cardItems[i + 1]);
          }
      }

      // Remove href from anchors without links
      const anchorElements = document.querySelectorAll(`#${widgetName} a`);
      anchorElements.forEach(anchor => {
          if (!anchor.getAttribute('href') || anchor.getAttribute('href') === '#') {
              anchor.removeAttribute('href');
          }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 6,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });

}
